import ActivateUserPage from "./ActivateUserPage";

export default ActivateUserPage;
